import { dramas } from '@/mocks/dramas';
import CategoryPage, { type CategoryConfig } from '@/pages/category/components/CategoryPage';

const classicList = dramas.filter((d) => d.isClassic || d.rating >= 8.5);

const config: CategoryConfig = {
  slug: 'classic',
  title: '经典剧集',
  subtitle: 'Classic Collection',
  intro:
    '经典剧集指经过时间检验、口碑长期稳定的伦理题材作品。它们或许节奏更慢，但对人物处境的描摹往往更耐心，也更值得反复回看。',
  description:
    '所谓经典，并不一定是当年最热的那一部，而是多年后仍有人愿意讨论的那一部。这里的作品多集中在 2016 至 2023 年之间，涵盖年代家族、乡土现实、匠人亲情与女性成长等方向。我们保留了每部作品的分集标题与章节梗概，方便按人物弧光重新梳理故事。评分为站内演示数据。',
  base: classicList,
};

export default function ClassicCategoryPage() {
  return <CategoryPage config={config} />;
}